import React from 'react';
import SeverityFace from '../SeverityFace';
import {
	monthMatrix,
	formatMonthName,
	formatMediumDate,
	WEEKDAY_INITIALS,
	todayISO,
} from '../../../../utils/journeyDates';
import styles from './MonthGrid.module.css';

// One month as a seven-column grid. The year view renders twelve of these at a
// smaller cell size, so the layout lives here and nothing is duplicated.
//
// A cell carries the highest rating across every goal in that day; that
// aggregation is the API's, and the goal filter is what makes a busy month
// readable.
const MonthGrid = ({
	year,
	monthIndex,
	ratingsByDate = {},
	cellSize = 30,
	compact = false,
	showTitle = false,
	onSelectDate,
}) => {
	const weeks = monthMatrix(year, monthIndex);
	const today = todayISO();

	return (
		<div className={`${styles.month} ${compact ? styles.compact : ''}`}>
			{showTitle && (
				<h4 className={styles.monthTitle}>{formatMonthName(monthIndex)}</h4>
			)}

			<div className={styles.weekdays} aria-hidden='true'>
				{WEEKDAY_INITIALS.map((initial, index) => (
					<span key={`${initial}-${index}`} className={styles.weekday}>
						{initial}
					</span>
				))}
			</div>

			<div className={styles.grid}>
				{weeks.flat().map((date, index) => {
					if (!date) {
						return <span key={`pad-${index}`} className={styles.pad} />;
					}

					const rating = ratingsByDate[date];
					const isToday = date === today;
					const label = rating
						? `${formatMediumDate(date)}, severity ${rating} of 5`
						: `${formatMediumDate(date)}, no entry`;

					const content = rating ? (
						<SeverityFace rating={rating} size={cellSize} showTitle={false} />
					) : (
						<span className={styles.emptyDay} />
					);

					return onSelectDate ? (
						<button
							key={date}
							type='button'
							className={`${styles.day} ${styles.dayButton} ${
								isToday ? styles.today : ''
							}`}
							onClick={() => onSelectDate(date)}
							aria-label={`${label}. Open the day view.`}
						>
							{content}
						</button>
					) : (
						<span
							key={date}
							className={`${styles.day} ${isToday ? styles.today : ''}`}
							title={label}
						>
							{content}
						</span>
					);
				})}
			</div>
		</div>
	);
};

export default MonthGrid;
